import { COLORS, RADIUS, SHADOWS, FONTS, fontFamilyFor } from "../../theme";

const fontFor = (isArabic) => fontFamilyFor(isArabic ? "ar" : "en");

export const Style = {
  main: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "calc(100vh - 180px)",
    color: COLORS.white,
    gap: "16px",
    p: { xs: "40px 16px 160px", sm: "40px 0 100px" },
    boxSizing: "border-box",
  },
  badgeCircle: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.peach})`,
    color: COLORS.forest,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    boxShadow: SHADOWS.card,
  },
  badgeCircleFail: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #c0392b, #e57373)",
    color: COLORS.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    boxShadow: SHADOWS.card,
  },
  statusText: (isArabic) => ({
    fontWeight: 800,
    color: COLORS.white,
    fontFamily: fontFor(isArabic),
    fontSize: "26px",
    textAlign: "center",
  }),
  message: (isArabic) => ({
    fontWeight: 400,
    fontFamily: fontFor(isArabic),
    fontSize: "15px",
    color: "rgba(255,255,255,0.6)",
    width: "100%",
    maxWidth: "335px",
    textAlign: "center",
    lineHeight: 1.5,
  }),
  ticketCard: {
    display: "flex",
    width: "100%",
    maxWidth: "380px",
    background: COLORS.forest,
    borderRadius: RADIUS.card,
    overflow: "hidden",
    boxShadow: SHADOWS.card,
    border: "1px solid rgba(255,255,255,0.08)",
    position: "relative",
    my: "8px",
  },
  ticketCardBody: (isArabic) => ({
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: isArabic ? "flex-end" : "flex-start",
    textAlign: isArabic ? "right" : "left",
    gap: "6px",
    padding: "22px 18px",
  }),
  admitOneLabel: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    color: COLORS.peach,
  }),
  ticketEventName: (isArabic) => ({
    fontFamily: isArabic ? fontFor(isArabic) : FONTS.heading,
    fontSize: "19px",
    fontWeight: 700,
    color: COLORS.white,
    lineHeight: 1.25,
  }),
  ticketMetaLine: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.3px",
    color: "rgba(255,255,255,0.65)",
  }),
  ticketLocation: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    color: "rgba(255,255,255,0.5)",
  }),
  ticketQty: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "13px",
    fontWeight: 700,
    color: COLORS.peach,
    mt: "6px",
  }),
  ticketStub: {
    width: "104px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    position: "relative",
    borderInlineStart: "2px dashed rgba(255,255,255,0.25)",
  },
  ticketQrImg: {
    width: "78px",
    height: "78px",
    background: COLORS.white,
    borderRadius: RADIUS.input,
    padding: "6px",
    boxSizing: "border-box",
    objectFit: "contain",
  },
  ticketNotch: (position) => ({
    position: "absolute",
    [position]: "-10px",
    insetInlineEnd: "94px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: COLORS.dark,
    zIndex: 1,
  }),
  orderNumber: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "13px",
    color: "rgba(255,255,255,0.45)",
    textAlign: "center",
  }),
  actionButton: (isArabic) => ({
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    color: `${COLORS.dark} !important`,
    background: COLORS.peach,
    "&:hover": { background: COLORS.gold },
    maxWidth: { xs: "600px", sm: "300px" },
    height: "56px",
    borderRadius: RADIUS.pill,
    boxShadow: SHADOWS.pill,
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100vw - 40px)", sm: "100%" },
    bottom: "120px",
    left: "20px",
  }),
  backButton: (isArabic) => ({
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    color: `${COLORS.white} !important`,
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.3)",
    "&:hover": { borderColor: COLORS.gold, color: `${COLORS.gold} !important` },
    maxWidth: { xs: "600px", sm: "300px" },
    height: "56px",
    borderRadius: RADIUS.pill,
    boxShadow: "none",
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100vw - 40px)", sm: "100%" },
    bottom: "40px",
    left: "20px",
  }),
};
